import { render, staticRenderFns } from "./CostBearerUploadQrcodeDocument.vue?vue&type=template&id=388dfa83"
import script from "./CostBearerUploadQrcodeDocument.vue?vue&type=script&lang=ts"
export * from "./CostBearerUploadQrcodeDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports